import { useEffect } from "react";
import Footer from "../Components/Footer/Footer";
import Navbar from "../Components/Navbar/Navbar";
import Aos from "aos";
import LeftSide from "../Components/Side.jsx/LeftSide";
import Right from "../Components/Side.jsx/Right";

// eslint-disable-next-line react/prop-types
const Layout = ({ children }) => {
  useEffect(() => {
    Aos.init({ duration: "1500" });
    Aos.refresh();
  });
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <section className="d-md-block d-none">
        <LeftSide />
        <Right />
      </section>
      <Footer />
    </>
  );
};

export default Layout;
